import './App.css';

// This dashboard is retired. Vendors now use the portal at vendors.taxreliefhelpers.co.
// The old login, dashboard and report components are left in src/components for
// reference but are no longer imported, so they (and the API credential they read)
// stay out of the build.
const NEW_PORTAL_URL = 'https://vendors.taxreliefhelpers.co/login';

function App() {
  return (
    <main className="moved">
      <div className="moved-card">
        <span className="moved-mark" aria-hidden="true" />
        <h1>This dashboard has moved</h1>
        <p className="moved-lede">
          Your reports now live in the new Tax Relief Helpers vendor portal.
          This page is no longer updated.
        </p>
        <a className="moved-button" href={NEW_PORTAL_URL}>Go to the new portal</a>
        <div className="moved-help">
          <p>
            Your existing email and password should work. If they don't,
            use "Forgot your password?" on the new portal to set a new one.
          </p>
          <p>
            Questions? <a href="mailto:dev@taxreliefhelpers.com">dev@taxreliefhelpers.com</a>
          </p>
        </div>
      </div>
    </main>
  );
}

export default App;
